import { ISearchPromosV2ResponseSchema } from '../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPromosActionTypes {
  Request = 'FILTERING_PROMOS/REQUEST',
  Success = 'FILTERING_PROMOS/SUCCESS',
  Failure = 'FILTERING_PROMOS/FAILURE',
}

export type TPromosSuccess = ITypedReduxAction<EPromosActionTypes.Success, ISearchPromosV2ResponseSchema>;
export type TPromosRequest = ITypedReduxAction<EPromosActionTypes.Request>;
export type TPromosFailure = ITypedReduxAction<EPromosActionTypes.Failure>;

/**
 * Redux action, который записывает в store список акций
 * @param promos TSearchPromosResponse_1
 */
export const promosSuccess: (promos: ISearchPromosV2ResponseSchema) => TPromosSuccess = actionGenerator<
  EPromosActionTypes.Success,
  ISearchPromosV2ResponseSchema
>(EPromosActionTypes.Success);

export const promosRequest: () => TPromosRequest = actionGenerator<EPromosActionTypes.Request>(
  EPromosActionTypes.Request,
);

export const promosFailure: () => TPromosFailure = actionGenerator<EPromosActionTypes.Failure>(
  EPromosActionTypes.Failure,
);

export type TPromoActionTypes = TPromosRequest | TPromosSuccess | TPromosFailure;
